import {
  UPDATE_USER_DETAIL,
  UPDATE_CLIENT_DETAIL,
  STATE_CHANGED,
  LOCATION_CHANGED,
  CLIENT_DATA_CHANGED,
  VEHICLES_FETCHED,
  LOGS_FETCHED,
  NOTIFICATIONS_FETCHED
} from './constants'

export const updateUserData = (user) => {
  return {
    type: UPDATE_USER_DETAIL,
    user
  }
}

export const updateClientData = (client) => {
  return {
    type: UPDATE_CLIENT_DETAIL,
    client
  }
}

// updates only on value of client
export const clientDataChanged = (name, value) => {
  return {
    type: CLIENT_DATA_CHANGED,
    name, value
  }
}

export const stateChanged = (id, name) => {
  return {
    type: STATE_CHANGED,
    state: {
      id,
      name
    }
  }
}

export const locationChanged = (location) => {
  const id =  location.value
  const name = location.label
  return {
    type: LOCATION_CHANGED,
    location: {
      id,
      name
    }
  }
}

export const vehiclesFetched = (vehicles) => {
  return {
    type: VEHICLES_FETCHED,
    vehicles
  }
}

export const reportLogsFetched = (logs) => {
  return {
    type: LOGS_FETCHED,
    logs
  }
}

export const notificationsFetched = (logs) => {
  return {
    type: NOTIFICATIONS_FETCHED,
    logs
  }
}



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/actions.js